const ApiBaseUrl = window.location.origin + '/api/';
export default ApiBaseUrl;
